import { useNavigate } from 'react-router-dom';

import { useNotificacoes as useNotificacoesDoNucleo } from '@maestra/core/telas/conta/useNotificacoes';
import { message } from '../../ui-carbon/padroes/avisos';

// AS NOTIFICAÇÕES: a regra (a lista paginada, ao vivo, agrupada por perfil, marcar, limpar, abrir o
// link) mora no núcleo desde 31/10/2026, e o app usa a mesma (docs/PLANO-APP-NATIVO.md).
export { agruparPorArtista } from '@maestra/core/telas/conta/useNotificacoes';
export type { GrupoDeNotificacoes } from '@maestra/core/telas/conta/useNotificacoes';

export const useNotificacoes = (onde: 'pagina' | 'painel' = 'pagina') => {
  const navigate = useNavigate();
  return useNotificacoesDoNucleo({ ir: navigate, avisar: message }, onde);
};
